import flex from './FlexFetch'

const endpoint = '/api/1.0/sms-actions/'

async function redeem(token) {
  try {
    const response = await flex.flexFetch(endpoint + 'redeem', {
      method: 'POST',
      body: JSON.stringify({ token }),
      credentials: 'include',
    })

    const data = await response.json()

    if (response.ok) {
      return { success: true, data: data.data }
    }

    return {
      success: false,
      status: response.status,
      errorCode: data?.error?.code || data?.errorCode || 'UNKNOWN',
      message: data?.error?.message || data?.message || 'Request failed',
    }
  } catch {
    return {
      success: false,
      status: 0,
      errorCode: 'REQUEST_FAILED',
      message: 'Unable to complete this request right now.',
    }
  }
}

const ApiSmsActions = { redeem }
export default ApiSmsActions
